import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, } from 'react-bootstrap';
import Alert from 'components/ui/Alert';
import ErrorAlert from 'components/ui/ErrorAlert';
import TripsActionCreator from '../../../../actions/TripsActionCreator';
import TripFormStore from '../../../../stores/TripFormStore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
class GenerateTripModal extends Component {
    constructor(props) {
        super(props);
        this.handleClose = () => this.props.onClose();
        this.handleTripFormChange = () => {
            const tripContext = TripFormStore.getTripContext();
            const { formStatus, } = tripContext;
            this.setState({
                formStatus,
            });
        };
        this.handleTripGeneratedEvent = () => {
            setTimeout(() => this.props.onClose(), 500);
        };
        this.handleTripGeneratedEvent = () => {
            const tripContext = TripFormStore.getTripContext();
            const { formStatus, } = tripContext;
            this.setState({
                formStatus,
            }, () => {
                const { formStatus: { completed, success, }, } = this.state;
                if (completed && success) {
                    setTimeout(() => this.props.onClose(), 500);
                }
            });
        };
        this.handleNameChange = e => this.setState({
            name: e.target.value,
        });
        this.handleGenerateTrip = () => TripsActionCreator.generateTrip(this.transformPayload());
        this.handleCloseSaveErrorAlert = () => this.setState((prevState) => {
            const { formStatus: currentFormStatus, } = prevState;
            const formStatus = Object.assign(Object.assign({}, currentFormStatus), { completed: false, error: null });
            return {
                formStatus,
            };
        });
        this.handleCloseSuccessAlert = () => this.setState((prevState) => {
            const { formStatus: currentFormStatus, } = prevState;
            const formStatus = Object.assign(Object.assign({}, currentFormStatus), { completed: false });
            return {
                formStatus,
            };
        });
        this.state = {
            name: '',
            formStatus: {
                pending: false,
                completed: false,
                success: false,
                error: null,
            },
        };
    }
    componentDidMount() {
        TripFormStore.addChangeListener(this.handleTripFormChange);
        TripFormStore.addTripGeneratedEventListener(this.handleTripGeneratedEvent);
    }
    componentWillUnmount() {
        TripFormStore.removeChangeListener(this.handleTripFormChange);
        TripFormStore.removeTripGeneratedEventListener(this.handleTripGeneratedEvent);
    }
    submitDisabled() {
        const { shipments, } = this.props;
        const { name, } = this.state;
        return shipments.length === 0 || !name;
    }
    transformPayload() {
        const { shipments, orderId, } = this.props;
        const { name, } = this.state;
        const mappedShipments = shipments.reduce((request, shipment) => {
            const type = shipment.status === 'Staging' ? 'shipments_staging' : 'shipments';
            if (!request.hasOwnProperty(type)) {
                request[type] = [shipment._id];
            }
            else {
                request[type] = request[type].concat(shipment._id);
            }
            return request;
        }, {});
        return Object.assign({ name,
            orderId }, mappedShipments);
    }
    render() {
        const { show, t, } = this.props;
        const { formStatus, } = this.state;
        return (React.createElement(Modal, { show: show, onHide: this.handleClose, enforceFocus: false },
            React.createElement(Modal.Header, { closeButton: true },
                React.createElement(Modal.Title, null, t('GENERATE_TRIP'))),
            React.createElement(Modal.Body, null,
                React.createElement("section", { className: "mb-4" },
                    React.createElement("label", { className: "form-label mb-2 block" }, t('WHATS_TRIP_NAME')),
                    React.createElement("input", { type: "text", placeholder: t('TRIP_NAME'), value: this.state.name, onChange: this.handleNameChange, className: "form-field" }))),
            React.createElement(Modal.Footer, null,
                React.createElement("div", { className: "flex justify-end mb-2" },
                    React.createElement("button", { className: "button button-green mr-2", onClick: this.handleGenerateTrip, disabled: this.submitDisabled() }, t('GENERATE_TRIP')),
                    React.createElement("button", { className: "button button-secondary", onClick: this.handleClose }, titleize(t('CANCEL')))),
                formStatus.completed && !formStatus.success && (React.createElement("div", { className: "w-full" },
                    React.createElement(ErrorAlert, { title: t('ERROR_WHILE_GERERATING_TRIP'), canClose: true, onClose: this.handleCloseSaveErrorAlert }))),
                formStatus.completed && formStatus.success && (React.createElement("div", { className: "w-full" },
                    React.createElement(Alert, { title: t('TRIP_GERNERATED_SUCCSSFULLY'), type: "success", canClose: true, onClose: this.handleCloseSuccessAlert }))))));
    }
}
GenerateTripModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    orderId: PropTypes.string.isRequired,
    shipments: PropTypes.arrayOf(PropTypes.shape({
        _id: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired,
    })),
};
export default withTranslation()(GenerateTripModal);
